<template>
  <div class="city-bank__search-box mb-xl-2">
    <a href="javascript:void(0)"
       role="button"
       aria-label="Search icon"
       @click="openModal">
      <svg class="heroicon-svg"
           xmlns="http://www.w3.org/2000/svg"
           fill="none"
           viewBox="0 0 24 24"
           stroke="currentColor">
        <path stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
      </svg>
    </a>
    <modal :modalClasses="modalClass"
           :dialogClasses="dialogClass"
           :showButtons="false"
           :modalOptions="options"
           @modalMounted="handleMount($event)">
      <template v-slot>
        <div class="d-flex">
          <label class="visually-hidden"
                 for="searchInput">Search input</label>
          <input type="text"
                 v-model="searchInput"
                 placeholder="Search"
                 class="form-control"
                 id="searchInput"
                 name="searchInput" />
          <a href="javascript:void(0)"
             role="button"
             @click="closeModal"
             aria-label="Close Search"
             class="search-close__button btn btn-primary">
            <svg xmlns="http://www.w3.org/2000/svg"
                 class="heroicon-svg"
                 fill="none"
                 viewBox="0 0 24 24"
                 stroke="currentColor">
              <path stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M6 18L18 6M6 6l12 12" />
            </svg>
          </a>
        </div>
        <div class="search-modal__inner">
          <ul class="list-unstyled m-0"
              v-show="!loading">
            <li v-for="(item, index) in results"
                :key="`search-result__${index}`">
              <div v-html="item"></div>
            </li>
          </ul>
          <div class="d-flex justify-content-center">
            <div class="spinner-border text-primary"
                 role="status"
                 v-show="loading">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
      </template>
    </modal>
  </div>
</template>
<script>
  import { ref, onMounted, watchEffect } from 'vue';
  import axios from 'axios';
  import { debounceInput } from '../helpers/debounce';
  import { useGtm } from "@gtm-support/vue-gtm";

  export default {
    props: {
      url: {
        type: String,
        required: true
      },
      id: {
        type: String,
        required: true
      },
      index: {
        type: String,
        required: true
      },
      fields: {
        type: String,
        required: true
      },
      language: {
        type: String,
        required: true
      }
    },
    setup(props) {
      const results = ref([]);
      const searchInput = ref('');
      const loading = ref(false);
      const dialogClass = 'modal-lg';
      const modalClass = 'fade';
      const options = {
        backdrop: false,
        keyboard: true,
        focus: false
      };
      const gtm = useGtm();
      let modal;

      const handleMount = (modalEvent) => {
        modal = modalEvent;
      };

      const openModal = () => {
        results.value = [
          '<p>Begin typing to start your search.</p>'
        ];
        modal.show();
        document.getElementById('searchInput').focus();
      };

      const closeModal = () => {
        modal.hide();
      };

      let timer;

      const debouncedGtmEvent = (config, timeout = 2000) => {
        if (timer) clearTimeout(timer);
        timer = setTimeout(() => gtm.trackEvent(config), timeout);
      }

      const getResults = debounceInput((query) => {
        const route = `${props.url}?IndexName=${props.index}&SuggestionFields=${props.fields}&Text=${query}&Language=${props.language}&SiteId=${props.id}`;
        axios.get(route)
          .then((response) => {
            if (!response.data.Suggestions.length) {
              results.value = [
                '<p>No results match your search query, please try again.</p>'
              ];
            } else {
              results.value = response.data.Suggestions
            }
            loading.value = false;
            debouncedGtmEvent({
              event: "search",
              category: "Website search",
              action: document.title,
              label: query,
              value: response.data.Suggestions.length,
              noninteraction: false,
            });
          })
          .catch((error) => {
            console.log(error);
            loading.value = false;
          });
      });

      const search = (query) => {
        if (query.length) {
          loading.value = true;
          getResults(query);
        } else {
          results.value = [
            '<p>Begin typing to start your search.</p>'
          ];
        }

      };

      watchEffect(
        () => search(searchInput.value)
      );

      onMounted(() => {
        // handle clicking outside of the modal
        const modalElement = document.querySelector('.city-bank__search-box .modal');
        document.addEventListener('click', (event) => {
          const outsideClick = event.target instanceof Element &&
            modalElement.contains(event.target) &&
            !modalElement.firstChild.contains(event.target)
          if (outsideClick) {
            event.stopPropagation();
            closeModal();
          }
        });
      });

      return {
        results,
        searchInput,
        search,
        openModal,
        closeModal,
        loading,
        dialogClass,
        modalClass,
        handleMount,
        options
      };
    }
  }
</script>
